/**
 * Friend Presence Query Keys
 */
export const contactKeys = {
  all: ['friends'] as const,
  friendsWithPresence: () => [...contactKeys.all, 'friends-with-presence'] as const
};
